import * as debug from '../services/debug.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivateChild, Router } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { NotificationService } from '../services/notification.service';
import { trimQueryString } from '../utils/utility.common';
import { environment } from 'src/environments/environment';
import { ProfileDbService } from '../services/profile-db.service';
import { SecurityService } from '../services/security.service';

@Injectable({ providedIn: 'root' })
export class RouteGuard implements CanActivate, CanActivateChild {

	constructor(private readonly router: Router
		, private readonly securityService: SecurityService
		, private readonly profileDbService: ProfileDbService
		, private readonly notification: NotificationService) {

	}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.allowActivation(next, state, 'canActivateParent');
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

		const urlNoQuerystring = trimQueryString(state.url);
		const isInProfilePicPage = this.isInProfilePicPage(urlNoQuerystring);

		debug.log(`010 RouteGuard isInProfilePicPage: ${isInProfilePicPage}`);

		return this.allowActivation(childRoute, state, 'canActivateChild');

	}

	isInProfilePicPage(url: string): boolean {

		const pattern = /\/profile\/pic/gi;
		const result = pattern.test(url);

		return result;

	}

	async allowActivation(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, source: string): Promise<boolean> {

		const currentUrlNoQuerystring = trimQueryString(state.url);

		debug.log(`011 RouteGuard state:`, state);
		debug.log(`012 RouteGuard route:`, route);
		debug.log(`012.1 RouteGuard source: ${source}`);

		if (currentUrlNoQuerystring.startsWith('/signin-callback')
			|| currentUrlNoQuerystring.startsWith('/signout-callback')
			|| currentUrlNoQuerystring.startsWith('/email-already-registered')
			|| currentUrlNoQuerystring === '/'
			|| currentUrlNoQuerystring === '') {

			return Promise.resolve(true);

		}

		const allowPublic = route.data.allowPublic; // See app.routing

		if (allowPublic) {

			return Promise.resolve(true);

		}

		const isLoggedIn = await this.securityService.isLoggedIn('085 RouteGuard');
		const dbMenus = await this.profileDbService.getMenus(isLoggedIn, `085.1 RouteGuard isLoggedIn: ${isLoggedIn}`); // Retrieve from local Db
		// find url from db menus
		const regEx = /\/(\d+)/g; // handle routes for edit
		const menu = dbMenus.find(dbMenu => {

			// replace the route value to match the pattern in module route configurations
			const revertedModuleRoute = currentUrlNoQuerystring.replace(regEx, '/:id');
			const isEqual = revertedModuleRoute === dbMenu.routerLink;

			// debug.warn(`${dbMenu.routerLink} === ${origRoute}`);

			return isEqual;

		});
		const canNavigate = menu ? true : false;

		if (!canNavigate) {

			debug.warn(`086 ${currentUrlNoQuerystring} is not registered in the database. isLoggedIn: ${isLoggedIn}`);

			if (!environment.production) {

				debug.warn(`086.1 You're not authorized to use ${currentUrlNoQuerystring}. isLoggedIn: ${isLoggedIn}`);
				debug.warn(`086.11 RouteGuard state:`, state);
				debug.warn(`086.12 RouteGuard route:`, route);
				debug.warn(`086.13 RouteGuard source: ${source}`);

				this.notification.showWarning(`You're not authorized to use ${currentUrlNoQuerystring}.`);

			}

			return this.router.navigate(['/']);

		} else {

			if (isLoggedIn) {

				const profile = await this.profileDbService.getLocalProfile(isLoggedIn, '016 MenuResolverService resolve');
				const recommendedLogin = profile.recommendedLogin;

				if (!!recommendedLogin) {

					debug.log(`086.2 recommendedLogin: ${recommendedLogin}`);

				}

				if (!!recommendedLogin) {

					return this.router.navigate(['/email-already-registered']);

				}

				if (!profile.isActive) {

					return this.router.navigate(['/pricing']);

				}
			}
		}

		return Promise.resolve(canNavigate);
	}
}
